import { Box, Button } from '@nimbus-ds/components';
import { InitialScreen } from '@nimbus-ds/patterns';
import { useTranslation } from 'react-i18next';
import HelpLink from 'App/HelpLink';
import { useNavegate } from 'App/hooks';
import { HELP_LINKS_PRODUCTS_TRANSFERS } from 'commons/constants/externalLinks';
import { useTranslationLanguage } from 'commons/hooks';
import { CATALOG_ROUTES } from 'domains/Catalog/catalogRoutes';

function ProductsTransfersEmpty() {
  const language = useTranslationLanguage();
  const { goTo } = useNavegate();
  const { t } = useTranslation('catalog');

  return (
    <Box display="flex" flexDirection="column" gap="12">
      <InitialScreen>
        <InitialScreen.Hero
          title={t('transfers.emptyState.title')}
          subtitle={t('transfers.emptyState.subtitle')}
          description={t('transfers.emptyState.description')}
          actions={
            <Button
              appearance="primary"
              onClick={() => goTo(CATALOG_ROUTES.newTransfer)}
            >
              {t('transfers.emptyState.action')}
            </Button>
          }
          image={
            <img
              src="https://d26lpennugtm8s.cloudfront.net/assets/common/img/empty-screens/empty-orders.png"
              alt="transfers-products-empty-state"
              width="100%"
            />
          }
        />
      </InitialScreen>
      <HelpLink
        title={t('transfers.emptyState.helpLink')}
        linkURL={HELP_LINKS_PRODUCTS_TRANSFERS[language]}
        previousValue=""
        currentViewTracking=""
        icon="both"
        showInMobile
      />
    </Box>
  );
}

export default ProductsTransfersEmpty;
